"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkshopListStyled = void 0;
exports.WorkshopListStyled = styled.div.attrs({ className: 'octo' }) `
&.octo {
  display: flex;
  flex-flow: column nowrap;
  gap: 1.5em;
  align-items: stretch;
  justify-content: flex-start;

  >.count {
    font-weight: 600;
  }
}
`;
//# sourceMappingURL=WorkshopList.styled.js.map